import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ButtonHOC from '../../hoc/buttonHOC';

const EmailField = ({ email, handleEmailToggle }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-4 row-title mb-md-0 mb-2">
          <FontAwesomeIcon icon="envelope" className="mt-1" />
          Email Address{' '}
        </div>
        <div className="col-md-8">
          <div className="d-flex align-items-center justify-content-between">
            {email}
            <ButtonHOC>
              <FontAwesomeIcon
                icon="pencil-alt"
                className="float-right mt-1 mr-3 cursor"
                onClick={handleEmailToggle}
              />
            </ButtonHOC>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EmailField;



// WEBPACK FOOTER //
// ./src/components/users/details/EmailField.js